import { Link } from "react-router-dom";
import { Carte } from "@/composants/ui/carte";
import { Vide } from "@/composants/ui/etats";

export function PageIntrouvable() {
  return (
    <Carte>
      <Vide
        titre="Cette page n'existe pas"
        detail="Le lien est peut-être ancien, ou la Commande / Projet a été supprimée."
      />
      <p className="pb-6 text-center">
        <Link to="/" className="text-sm font-medium text-laiton-fonce underline underline-offset-4">
          Revenir aux Commandes / Projets
        </Link>
      </p>
    </Carte>
  );
}
